import createReducer from '../utils/createReducer';
import listingExtendedActions from '../actions/listingExtendedActions';

const initialState = {};

const actionHandlers = {
    [listingExtendedActions.FETCH_URGENCY_MESSAGE_SUCCESS](state, {payload}) {
        const {urgencyMessage} = payload;
        return {
            ...state,
            urgencyMessage
        };
    },
    [listingExtendedActions.FETCH_BADGES_SUCCESS](state, {payload}) {
        const {badges} = payload;
        return {
            ...state,
            badges
        };
    },
    [listingExtendedActions.FETCH_RANKED_BADGES_SUCCESS](state, {payload}) {
        const {rankedBadges} = payload;
        return {
            ...state,
            rankedBadges
        };
    },
    [listingExtendedActions.FETCH_DISCOVERY_SUCCESS](
        state,
        {
            payload: {discoveryFeed}
        }
    ) {
        return {
            ...state,
            discoveryFeed
        };
    },
    [listingExtendedActions.FETCH_UNIT_SPACES_SUCCESS](state, {payload}) {
        const {unitSpaces} = payload;
        return {
            ...state,
            unitSpaces
        };
    },
    [listingExtendedActions.FETCH_CONTENT_ITEMS_SUCCESS](state, {payload}) {
        const {unitContentItems, propertyContentItems, unitMetadata} = payload;
        return {
            ...state,
            unitContentItems,
            propertyContentItems,
            unitMetadata
        };
    },
    [listingExtendedActions.FETCH_HOUSE_RULES_SUCCESS](state, {payload}) {
        const {houseRules} = payload;
        return {
            ...state,
            houseRules
        };
    },
    [listingExtendedActions.FETCH_RECOMMENDED_PROPERTIES_SUCCESS](state, {payload}) {
        const {recommendedProperties} = payload;
        return {
            ...state,
            recommendedProperties,
            recommendedPropertiesFetchSuccess: true
        };
    },
    [listingExtendedActions.FETCH_RECOMMENDED_PROPERTIES_FAILED](state) {
        return {
            ...state,
            recommendedPropertiesFetchFailed: true
        };
    },
    [listingExtendedActions.FETCH_BY_OWNER_PROPERTIES_SUCCESS](state, {payload}) {
        const {byOwnerProperties} = payload;

        return {
            ...state,
            byOwnerProperties,
            byOwnerPropertiesFetchSuccess: true
        };
    },
    [listingExtendedActions.FETCH_BY_OWNER_PROPERTIES_FAILED](state) {
        return {
            ...state,
            byOwnerPropertiesFetchFailed: true
        };
    },
    [listingExtendedActions.FETCH_REGISTRATION_NUMBER_SUCCESS](state, {payload}) {
        const {registrationNumber} = payload;
        return {
            ...state,
            registrationNumber
        };
    },
    [listingExtendedActions.FETCH_GEO_DISTANCE_SUCCEES](state, {payload}) {
        const {geoRelativeDistances} = payload;
        return {
            ...state,
            geoRelativeDistances
        };
    }
};

export default createReducer(actionHandlers, initialState);
